import type { Catalog } from "../en";
import { webappPortal } from "./webapp-portal";

/** Web app — Filipino (FIL dict from mockups/app/login.html, screens §2.1; Taglish where natural). */
export const webapp: Catalog["webapp"] = {
  tenant: {
    notFoundTitle: "Hindi available dito ang assistant na ito",
    notFoundBody: "I-check ang link mula sa organisasyon mo, o buksan ang address na ibinigay nila.",
    errorTitle: "Hindi namin ma-load ang assistant",
    errorBody: "I-check ang koneksyon mo at subukan ulit.",
  },
  find: {
    title: "Hanapin ang organisasyon mo",
    body: "Buksan ang link na ibinigay ng organisasyon mo, o ilagay ang pangalan sa dulo ng link na iyon.",
    label: "Pangalan sa link ng organisasyon",
    placeholder: "iyong-organisasyon",
    hint: "Halimbawa: {{example}}",
    submit: "Buksan ang assistant",
    invalid: "Mga titik, numero at gitling lang ang puwede.",
  },
  language: {
    label: "Wika",
    en: "English",
    fil: "Filipino",
    setEn: "Language set to English",
    setFil: "Filipino na ang wika",
  },
  login: {
    siteLinkHint: "Bubuksan ang {{host}}",
    tagline: "Ang opisyal na AI assistant ng {{org}}",
    badgeLanguages: "English · Filipino · Taglish",
    badgeOpen: "Bukas 24/7",
    guest: "Magpatuloy bilang guest",
    guestBody: "Pampublikong sagot lang — serbisyo, presyo, iskedyul",
    divider: "Mga miyembro",
    portal: "Mag-sign in gamit ang portal ng organisasyon mo",
    portalUnavailable: "Hindi pa naka-set up ang pag-sign in gamit ang portal ng organisasyon para sa assistant na ito.",
    google: "Mag-sign in gamit ang Google",
    otp: "Mag-sign in gamit ang email code",
    privacy: "Pinoproseso ng {{org}} ang mga usapan alinsunod sa kanilang privacy notice at itinatago nang {{months}} buwan. Huwag magbahagi ng password o bank details sa chat.",
    privacyLink: "Privacy Notice",
    privacyToast: "Dito bubukas ang Privacy Notice ng {{org}} kapag na-publish na.",
    help: "Nahihirapang mag-sign in?",
    helpLink: "Kontakin ang team",
    helpToast: "Kontakin ang {{org}} sa kanilang opisyal na channels para sa tulong sa pag-sign in.",
    poweredBy: "Powered by {{product}}",
    copyright: "© {{year}} {{org}}",
    announcementDismiss: "Isara ang anunsyo",
  },
  otp: {
    emailLabel: "Email address",
    emailPlaceholder: "ikaw@example.com",
    emailError: "Maglagay ng valid na email address.",
    emailHint: "Gamitin ang email address na naka-register sa {{org}}.",
    send: "I-email sa akin ang code",
    sentToast: "Kung naka-register ang email na ito, padating na ang code — valid nang 10 minuto",
    sentTo: "Nagpadala kami ng 6-digit code sa",
    change: "Palitan",
    digit: "Digit {{n}}",
    resendIn: "Ipadala ulit sa {{time}}",
    resend: "Ipadala ulit ang code",
    resentToast: "Nagpadala ng bagong code",
    verify: "I-verify at magpatuloy",
    codeError: "Ilagay ang 6-digit code mula sa email.",
    unavailable: "Hindi pa available ang pag-sign in gamit ang email. Magpatuloy bilang guest para sa pampublikong sagot.",
    failed: "Hindi namin ma-verify ang code. I-check at subukan ulit.",
  },
  sidebar: {
    label: "Mga chat",
    close: "Isara ang menu",
    open: "Buksan ang menu",
    newChat: "Bagong chat",
    search: "Hanapin ang chats",
    history: "History ng chat",
    groups: {
      pinned: "Naka-pin",
      today: "Ngayong araw",
      yesterday: "Kahapon",
      previous7: "Nakaraang 7 araw",
      older: "Mas luma",
    },
    emptyTitle: "Wala pang chat",
    emptyBody: "Lalabas dito ang mga tanong mo para maituloy mo ang usapan.",
    noMatches: "Walang chat na tugma sa “{{query}}”.",
    guestNote: "Naka-save lang sa device na ito ang guest chats. Mag-sign in para manatili ang history mo kahit saan.",
    options: "Mga opsyon ng chat",
    rename: "Palitan ang pangalan",
    renamePrompt: "Pangalan ng chat",
    renameSave: "I-save ang pangalan",
    pin: "I-pin",
    unpin: "Alisin sa pin",
    delete: "Alisin sa device na ito",
    deleted: "Inalis ang chat sa device na ito",
    deleteServer: "Burahin ang chat",
    deletedServer: "Nabura ang chat",
    transcript: "I-download ang transcript",
    transcriptDone: "Na-download ang transcript (.txt)",
    transcriptFailed: "Hindi ma-download ang transcript. Subukan ulit.",
    loadError: "Hindi ma-load ang mga chat mo.",
    loadMore: "Ipakita ang mas lumang chats",
  },
  announcements: {
    title: "Mga anunsyo",
    newCount_one: "{{count}} bago",
    newCount_other: "{{count}} bago",
    urgent: "Urgent",
    pinned: "Anunsyo",
    expires: "Sasagutin ng {{app}} ang mga tanong tungkol sa anunsyong ito hanggang {{date}}.",
    notify: "Abisuhan ako sa updates",
    notifyToast: "Hindi pa available ang email alerts — bumalik dito para sa mga pagbabago.",
    close: "Isara",
  },
  session: {
    signedIn: "Naka-sign in ka na",
    ssoFailed: "Hindi ka namin ma-sign in gamit ang portal ng organisasyon mo. Subukan ulit mula sa portal.",
  },
  user: {
    menu: "Menu ng account",
    member: "Naka-sign in",
    verified: "Verified",
    signedInAs: "Naka-sign in bilang",
    signOut: "Mag-sign out",
    signedOut: "Naka-sign out ka na",
    guest: "Guest",
    guestRole: "Pampublikong sagot lang",
    guestNote: "Hindi ka naka-sign in. Mag-sign in para sa mga sagot na pang-miyembro lang.",
    signIn: "Mag-sign in",
    theme: "Palitan ang theme",
    language: "Wika",
    languageAuto: "Auto",
    languageToast: "Sinusundan ng wika ang mga mensahe mo — English, Filipino o Taglish",
  },
  yourData: {
    download: "I-download ang data ko",
    erase: "Burahin ang data ko",
    downloaded: "Na-download ang data mo",
    downloadFailed: "Hindi namin naihanda ang data mo. Pakisubukan muli.",
    rateLimited: "Ilang beses mo na itong sinubukan. Maghintay muna bago subukan ulit.",
    eraseTitle: "Buburahin ang data mo?",
    eraseIntro: "Permanenteng buburahin nito, sa bawat assistant sa chat ng {{org}}:",
    eraseConversations: "ang mga usapan mo at ang feedback mo sa mga sagot",
    eraseContact: "ang pangalan, email at numero ng telepono na ibinahagi mo, at ang mga sagot mo sa mga form",
    eraseKeep: "Mananatili sa {{org}} ang mga inquiry at booking na naipadala mo na. Hindi na ito mababawi, at magsisimula muli ang browser na ito.",
    eraseSignedIn: "Mananatili kang naka-sign in.",
    eraseConfirm: "Burahin ang data ko",
    eraseCancel: "Panatilihin ang data ko",
    erased: "Nabura ang data mo",
    eraseFailed: "Hindi namin nabura ang data mo. Pakisubukan muli.",
  },
  header: {
    chooseAssistant: "Pumili ng assistant",
    assistantMenu: "Assistant: {{name}}",
    switched: "Lumipat sa {{name}}",
    publicTag: "Bukas sa lahat",
    share: "I-share",
    shareUnavailable: "Malapit nang magamit ang pag-share ng link.",
    newChat: "Bagong chat",
    verified: "Verified",
    verifiedHint: "Puwedeng may pang-miyembrong impormasyon ang mga sagot",
  },
  welcome: {
    greeting: "Hi {{name}}! Paano kita matutulungan ngayon?",
    greetingGuest: "Hello! Paano kita matutulungan ngayon?",
    sub: "Magtanong sa English, Filipino o Taglish. Sumasagot ako mula sa opisyal na dokumento ng {{org}} at ipinapakita ko ang source.",
    subGuest: "Guest ka ngayon, kaya pampublikong impormasyon lang ang gagamitin ko. Mag-sign in para sa mga sagot na pang-miyembro.",
    suggestions: "Mga puwedeng itanong",
    categories: {
      requirements: "Requirements at mga isusumite",
      fees: "Bayarin at paraan ng pagbabayad",
      scholarships: "Scholarship at discount",
      schedule: "Mga petsa at iskedyul",
      documents: "Mga dokumento at request",
      visit: "Pagbisita at appointment",
      general: "Magtanong sa assistant",
    },
  },
  composer: {
    label: "Mensahe",
    placeholder: "Magtanong dito…",
    attach: "Mag-attach ng file",
    attachToast: "Hindi pa naka-on ang attachments para sa assistant na ito.",
    voice: "Voice input",
    voiceToast: "Malapit na ang voice input — mag-type muna sa English o Filipino.",
    send: "Ipadala",
    stop: "Itigil ang pagsagot",
    enterToSend: "para ipadala",
    newLine: "bagong linya",
    disclaimer: "Galing sa opisyal na dokumento ng {{org}} ang mga sagot. Laging i-confirm ang bayarin sa kinauukulang opisina.",
    connecting: "Kumokonekta sa assistant…",
  },
  chat: {
    log: "Usapan",
    jump: "Pumunta sa pinakabago",
    loadingTranscript: "Nilo-load ang usapan",
    transcriptErrorTitle: "Hindi namin mabuksan ang chat na ito",
    transcriptErrorBody: "Baka sinimulan ito sa ibang device o browser.",
    startNew: "Magsimula ng bagong chat",
    visitorErrorTitle: "Hindi kami makakonekta sa assistant",
    visitorErrorBody: "I-check ang koneksyon mo at subukan ulit.",
    unsent: "Hindi naipadala · I-tap para subukan ulit",
    handoffConnecting: "Ikinokonekta ka sa {{team}}…",
    handoffConnectingGeneric: "Ikinokonekta ka sa isang staff…",
    handoffQueued: "Nasa pila ka para sa {{team}}",
    handoffJoined: "Sumali si {{name}} ({{role}}) sa usapan",
    handoffResolved: "Naresolba na ng staff ang usapang ito",
    handoffAiBack: "Bumalik na ang AI assistant",
    handoffWaitingTitle: "Naghihintay sa team",
    handoffWaitingTeam: "Sasagot po dito ang {{team}} sa lalong madaling panahon",
    handoffWaitingGeneric: "Sasagot po dito ang team sa lalong madaling panahon",
    queuePositionNext: "Kayo na po ang susunod sa pila",
    queuePosition: "Kayo po ang numero {{position}} sa pila",
    queueWaitRange: "Karaniwang mga {{low}}–{{high}} minuto",
    queueWaitUnder: "Karaniwang wala pang isang minuto",
    queueSoon: "Malapit na pong sumali ang isang teammate",
    staffTyping: "Nagta-type si {{name}}…",
    staff: "Staff",
    status: {
      thinking: "Nag-iisip…",
      working: "Inaasikaso na…",
      composing: "Inaayos ang sagot…",
      almost: "Malapit na…",
    },
    errors: {
      generic: "May nagkaproblema sa amin. Subukan ulit.",
      network: "Nawala ang koneksyon. I-check ang internet mo at subukan ulit.",
      rateLimited: "Busy ang assistant — subukan ulit pagkalipas ng isang minuto.",
      unsupported: "Hindi natanggap ng browser ang sagot. Subukan ulit.",
      retry: "Subukan ulit",
    },
    actions: {
      retry: "Subukan ulit",
      sending: "Ipinapadala…",
      detailsHeading: "Ang iyong mga detalye",
      required: "Kailangang punan ito",
      invalidEmail: "Maglagay ng wastong email address",
      invalidMobile: "Ilagay ang numero kasama ang country code, hal. +63 917 123 4567",
      contactRule: "Maglagay ng email o numero ng telepono para makontak ka namin",
      phoneHint: "Opsyonal · isama ang country code",
      choose: "Pumili…",
      consent: "Sumasang-ayon ako sa privacy notice",
      privacyLink: "Basahin ang privacy notice",
      consentRequired: "Pakitiyak na sumasang-ayon ka sa privacy notice para makapagpatuloy",
      checkField: "Pakisuri ang field na ito",
      leadSubmit: "Ipadala ang aking detalye",
      requestIntro: "Pumili ng oras at ipadala ang iyong detalye. Kokumpirmahin ito ng team sa email — hindi pa ito naka-book hangga't hindi nila ito kinukumpirma.",
      calendarIntro: "Pumili ng oras at agad itong ibo-book.",
      requestThisTime: "Hilingin ang oras na ito",
      bookThisTime: "I-book ang oras na ito",
      minutes: "{{count}} minuto",
      yourTime: "Napili mong oras",
      pickATime: "Pumili muna ng oras",
      chooseDay: "Pumili ng araw",
      chooseTime: "Pumili ng oras",
      loadingTimes: "Nilo-load ang mga available na oras",
      timesIn: "Nakalagay ang mga oras ayon sa iyong time zone ({{zone}})",
      dayChip_one: "{{date}}, {{count}} bukas na oras",
      dayChip_other: "{{date}}, {{count}} bukas na oras",
      showMoreDays: "Ipakita ang iba pang araw",
      loadingMoreDays: "Nilo-load ang iba pang araw",
      noTimesTitle: "Walang bukas na oras sa mga araw na ito",
      noTimesBody: "Subukan ang mga susunod na petsa.",
      nextOpen: "Ang susunod na bukas na oras ay {{when}}.",
      jumpTo: "Pumunta sa {{date}}",
      slotsError: "Hindi namin ma-load ang mga available na oras.",
      addToCalendar: "Idagdag sa kalendaryo",
      joinMeet: "Sumali sa video call",
      stateSent: "Naipadala",
      stateRequested: "Hindi pa kumpirmado",
      stateConfirmed: "Kumpirmado",
      stateFailed: "Hindi natapos",
      completed: "Tapos na",
      expired: "Nag-expire na ang request na ito — magtanong ulit",
      unavailable: "Hindi na available ang request na ito — magtanong ulit",
      slotTaken: "Kakakuha lang ng oras na iyon. Pumili ng iba.",
      validation: "Suriin ang mga naka-highlight na detalye at subukan ulit.",
      rateLimited: "Napakaraming subok. Subukan ulit pagkalipas ng {{seconds}} segundo.",
      rateLimitedNoWait: "Napakaraming subok. Maghintay sandali at subukan ulit.",
      serviceUnavailable: "Pansamantalang hindi available ito. Subukan ulit mamaya.",
      conflict: "Naipadala na ito o pinoproseso pa. Tingnan ang iyong email, o magtanong ulit.",
      captcha: "Hintayin munang matapos ang security check, saka subukan ulit.",
      signIn: "Mag-sign in para makapagpatuloy.",
      generic: "May nagkaproblema. Subukan ulit.",
      previewNote: "Preview — tumatakbo ang mga action para sa totoong bisita",
      previewTimes: "Dito lalabas ang mga bukas na oras para sa totoong bisita.",
    },
  },
  portal: webappPortal,
};
